import React from 'react'
import { useFormContext } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Button } from '../../../../UI'
import { EdkAPI } from '../../../../../services/api/Edk'
import { User } from '../../../../../services/api/User'
import styles from './UserEdk.module.scss'

export const UserEdk = () => {
  const { watch } = useFormContext<User>()
  const user = watch()
  const [edkList, setEdkList] = React.useState<string[]>([])
  const [loading, setLoading] = React.useState<boolean>(true)

  const download = (edk: string) => async () => {
    setLoading(true)
    try {
      const response: any = await EdkAPI.downloadUserEdk({ userId: user.id, symbol: edk })

      if (response.data) {
        // Декодируем Base64 в ArrayBuffer
        let arrayBuffer: ArrayBuffer
        if (typeof response.data === 'string') {
          const binaryString = window.atob(response.data)
          const len = binaryString.length
          const bytes = new Uint8Array(len)
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i)
          }
          arrayBuffer = bytes.buffer
        } else {
          arrayBuffer = response.data
        }

        // Создаём Blob
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        // Скачиваем файл
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${edk}.pdf`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        toast.success(`EDK ${edk} успешно скачан`)
      } else {
        toast.error(`Ошибка скачивания EDK ${edk}`)
        if (response.error) {
          toast.error(response.error.message)
        }
      }
    } catch (error: any) {
      toast.error(`Ошибка скачивания EDK ${edk}`)
      toast.error(error?.message)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    const fetchEdks = async () => {
      setLoading(true)
      try {
        const { data }: any = await EdkAPI.getUserEdk({ userId: user.id })
        if (data && data.data) {
          const items = data.data.items as { symbol: string; token: string }[]
          setEdkList(items.map((item) => item.symbol))
        } else {
          setEdkList([])
        }
      } catch {
        setEdkList([])
      } finally {
        setLoading(false)
      }
    }

    fetchEdks()
  }, [user.id])

  if (loading) {
    return <div>Загрузка...</div>
  }

  if (!edkList.length) {
    return <div>EDK не найдено</div>
  }

  return (
    <div className={styles.edkButtons}>
      {edkList.map((edk) => (
        <Button key={edk} onClick={download(edk)}>
          {edk}
        </Button>
      ))}
    </div>
  )
}
